<template>
  <div class="codemirror-container">
    <codemirror
      v-model="currCode"
      :options="cmOptions"
      class="code-mirror"
      @input="onCmCodeChange"
      ref="myCmGenerate"
      @beforeChange="onBeforeChange"
    >
    </codemirror>
  </div>
</template>
<script>
import { codemirror } from "vue-codemirror";
import "codemirror/mode/shell/shell.js";
import "codemirror/keymap/sublime";
import "codemirror/theme/material.css";

export default {
  name: "shell-code-mirror",
  components: {
    codemirror
  },
  data() {
    return {
      props: {
        jobDetail: undefined
      },
      cmOptions: {
        tabSize: 4, // tab
        indentUnit: 4,
        styleActiveLine: true, // 高亮选中行
        lineNumbers: true, // 显示行号
        styleSelectedText: true,
        line: true,
        foldGutter: true, // 块槽
        gutters: ["CodeMirror-linenumbers", "lock", "warn"],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true }, // 可以启用该选项来突出显示当前选中的内容的所有实例
        mode: "shell",
        // hint.js options
        hintOptions: {
          // 当匹配只有一项的时候是否自动补全
          completeSingle: false
        },
        // 快捷键 可提供三种模式 sublime、emacs、vim
        keyMap: "sublime",
        matchBrackets: true,
        showCursorWhenSelecting: false,
        // scrollbarStyle:null,
        readOnly: false, // 是否只读
        theme: "material", // 主题 material
        lineNumberFormatter: function() {
          return arguments[0] + this.lastLineBefore;
        },
        extraKeys: { Ctrl: "autocomplete" }, // 可以用于为编辑器指定额外的键绑定，以及keyMap定义的键绑定
        lastLineBefore: 0
      },
      CodeMirrorEditor: null,
      currCode: "#!/bin/bash\n",
      disableBeforeChange: false //用于临时禁用 onBeforeChange
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.CodeMirrorEditor = this.$refs.myCmGenerate.codemirror;
  },
  methods: {
    initReadOnly() {
      this.cmOptions.readOnly = true;
    },
    initCodeValue(code) {
      this.currCode = code;
      this.cmOptions.readOnly = true;
    },
    initShellValue(code) {
      this.currCode = code;
    },
    onCmCodeChange() {
      this.$emit("handleInputChange", this.currCode);
    },
    onBeforeChange(cm, change) {
      // 处理删除操作产生的空白行
      if (
        change.origin === "+delete" ||
        change.origin === "cut" ||
        change.origin === "paste"
      ) {
        // 获取当前所有内容
        const content = cm.getValue();
        const lines = content.split("\n");

        // 检查是否存在连续的空白行
        let hasConsecutiveEmptyLines = false;
        for (let i = 0; i < lines.length - 1; i++) {
          if (lines[i].trim() === "" && lines[i + 1].trim() === "") {
            hasConsecutiveEmptyLines = true;
            break;
          }
        }

        // 如果存在连续空白行，进行处理
        if (hasConsecutiveEmptyLines) {
          const newLines = lines.filter((line, index, arr) => {
            // 保留非空行
            if (line.trim() !== "") return true;
            // 保留前后都有内容的单个空行
            if (index > 0 && index < arr.length - 1) {
              const prevHasContent = arr[index - 1].trim() !== "";
              const nextHasContent = arr[index + 1].trim() !== "";
              return prevHasContent || nextHasContent;
            }
            return true;
          });

          // 更新内容
          const from = { line: 0, ch: 0 };
          const to = { line: lines.length, ch: 0 };
          cm.replaceRange(newLines.join("\n"), from, to);
        }
      }

      if (this.disableBeforeChange) {
        // 如果禁用 onBeforeChange，则跳过处理
        return;
      }
      const fromLine = change.from.line + 1;
      const toLine = change.to.line + 1;
      const disabledLines = this.getDisabledLines(cm);
      for (let i = fromLine; i <= toLine; i++) {
        if (disabledLines.includes(i)) {
          // 允许换行操作
          if (change.text.length === 2 && change.text[0] === "") {
            continue;
          }
          change.cancel();
          break;
        }
      }
    },
    getDisabledLines(cm) {
      const content = cm.getValue();
      const lines = content.split("\n");
      const disabledLines = [];
      const targetContents = [
        "#SBATCH -p",
        "#SBATCH -n",
        "#SBATCH --nodelist",
        "#SBATCH -N",
        "#SBATCH --ntasks-per-core"
      ];

      targetContents.forEach((target, index) => {
        lines.forEach((line, i) => {
          if (line.includes(target)) {
            disabledLines.push(i + 1);
          }
        });
      });

      return disabledLines;
    },
    disableOnBeforeChange() {
      this.disableBeforeChange = true;
    },
    enableOnBeforeChange() {
      this.disableBeforeChange = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.code-mirror {
  font-size: 13px;
  line-height: 150%;
}
</style>



// WEBPACK FOOTER //
// src/workspace/components/self-code-mirrors/shell-code-mirror.vue